import axios from "axios";
import { API_URL } from "src/scenes/App";
import { UserKeys } from "src/constants/userDetails";

export type QuestionType = "Rating" | "Satisfaction" | "Yes/No" | "Feedback";
export type SurveyType = QuestionType | "Multi Type";

export interface SurveyQuestion {
    uuid: string;
    question: string;
    questionOrder: number;
    surveyType: QuestionType;
    surveyUuid: string;
}

export interface AppSurvey {
    uuid: string;
    name: string;
    finishDate: string;
    surveyType: SurveyType;
    image: { imageUrl: string | null; isUsingCompanyLogo: boolean };
    answered: boolean;
    surveyQuestions: SurveyQuestion[];
    isAnonymous: boolean;
}

export interface SurveyAnswer {
    surveyQuestionUuid: string;
    answerOrFeedbackResponse: string;
}

export interface SurveyUser {
    uuid: string;
    surveyUuid: string;
    employeeUuid: string;
    submittedAt: string | null;
    presentedAt: string | null;
    dismissedForeverAt: string | null;
}

function headers(): { Authorization: string } {
    return { Authorization: `Bearer ${localStorage.getItem(UserKeys.TOKEN)}` };
}

export async function getActiveSurveys(signal: AbortSignal): Promise<AppSurvey[]> {
    const response = await axios.get<{ surveys: AppSurvey[] }>(`${API_URL}/survey/active`, { headers: headers(), signal });
    return response.data.surveys;
}

export async function submitSurveyAnswers(uuid: string, answers: SurveyAnswer[]): Promise<SurveyUser> {
    const response = await axios.post<{ surveyUser: SurveyUser }>(
        `${API_URL}/survey/responseSubmitted/${encodeURIComponent(uuid)}`,
        { surveyRequest: answers }, { headers: headers() }
    );
    return response.data.surveyUser;
}
